// Client-Aufrufe der UX-Vorschlaege (Web P1/P4/P5). Eigene Datei, damit der
// grosse lib/api.ts nicht von mehreren Agenten gleichzeitig bearbeitet wird.
// Vertrag: "api" (packages/shared → NeedsYouDto, PortfolioDto, InboxItemDto,
// MyDayOrderSchema, InboxReplySchema). Nur aktiv, wenn uxEnabled() es ist.

import type {
  InboxReplyResponse,
  NeedsYouDto,
  PersonalTask,
  PortfolioDto,
} from "@juuplan/shared";
import { api } from "./api";
import type { MeTaskLite } from "./needsYou";

export interface NeedsYouSources {
  needsYou: NeedsYouDto;
  /** Fuer „Diese Woche" (der Server liefert dafuer keine eigene Liste). */
  projectTasks: MeTaskLite[];
  personalTasks: PersonalTask[];
}

/**
 * Quellen fuer „Braucht dich" + „Diese Woche". GET-Fehler toastet api() NICHT —
 * der Aufrufer muss einen Fehler sichtbar machen, statt einen Leerzustand zu
 * zeigen (sonst ist „nichts braucht dich" eine Falschaussage).
 */
export async function fetchNeedsYouSources(day: string): Promise<NeedsYouSources> {
  const [needsYou, projectTasks, personalTasks] = await Promise.all([
    api<NeedsYouDto>(`/api/me/needs-you?today=${encodeURIComponent(day)}`),
    api<MeTaskLite[]>("/api/me/tasks"),
    api<PersonalTask[]>("/api/personal-tasks"),
  ]);
  return { needsYou, projectTasks, personalTasks };
}

/** P1: Reihenfolge der Eintraege eines Tages setzen (204; 404 = fremde/alte id). */
export function reorderMyDay(day: string, entryIds: number[]): Promise<void> {
  return api<void>("/api/my-day/order", {
    method: "PUT",
    body: { day, entry_ids: entryIds },
  });
}

/**
 * P5/P1: Antwort auf einen Inbox-Eintrag — Kommentar an der Aufgabe UND
 * Eintrag erledigt in EINEM Aufruf (Server erwaehnt den Verfasser mit).
 */
export function replyToInboxItem(
  sourceType: string,
  sourceId: number,
  body: string,
): Promise<InboxReplyResponse> {
  return api<InboxReplyResponse>(
    `/api/inbox/${encodeURIComponent(sourceType)}/${sourceId}/reply`,
    { method: "POST", body: { body } },
  );
}

/** P4: Projektliste mit Kennzahlen. */
export function fetchPortfolio(day: string): Promise<PortfolioDto> {
  return api<PortfolioDto>(`/api/portfolio?today=${encodeURIComponent(day)}`);
}
